import * as React from 'react';
import Div from "@jumbo/shared/Div";
import ContentWrapper from 'app/components/ContentWrapper/ContentWrapper';
import { Card, Chip, Typography } from "@mui/material";
import MobileFooter from 'app/components/MobileFooter/MobileFooter';
import MobileHeader from 'app/components/MobileHeader/MobileHeader';
import InputIcon from 'app/components/InputIcon/InputIcon';
import DialogActions from '@mui/material/DialogActions';
import { useLocation, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { requestApi } from 'app/utils/RestApi';
import ButtonStyled from 'app/components/ButtonStyled/ButtonStyled';
import { REFERRER } from 'app/utils/constants/endPoint';
import { isMobile } from 'react-device-detect';
import { Field, Form, Formik } from 'formik';
import { setupParamsReferrer } from 'app/services/setupWebview';
import { Col, Row } from 'react-bootstrap';
import SearchIcon from "@mui/icons-material/Search";
import { convertDate } from 'app/utils/appHelpers';
import addReferrerTerminatedSchema from './addReferrerTerminatedSchema';

const WebviewAddReferrerTerminated = () => {
	const navigate = useNavigate();

	const location = useLocation()

	const [fieldTouched, setFieldTouched] = React.useState({
		ktpNumber: false,
	});

	const navigateBack = () => {
		navigate(-1);
	};

	const [formData, setFormData] = React.useState()
	const [agentCode, setAgentCode] = React.useState("")


	React.useEffect(() => {
		// if (!isMobile) {
		// 	Swal.fire({
		// 		icon: 'warning',
		// 		title: 'Forbidden!',
		// 		text: 'Halaman ini tidak dapat diakses melalui browser',
		// 		allowOutsideClick: false,
		// 		showConfirmButton: false
		// 	});
		// } else {
		// 	let parameter = localStorage.getItem('paramsReferrer')
		// 	console.log('parameter : ', parameter);
		// 	if (!parameter) parameter = location.search
		// 	setupParamsReferrer(parameter, ({ agentCode }) => {
		// 		setAgentCode(agentCode)
		// 	}, false, navigateBack)
		// }
		let parameter = localStorage.getItem('paramsReferrer')
		console.log('parameter : ', parameter);
		if (!parameter) parameter = location.search
		setupParamsReferrer(parameter, ({ agentCode }) => {
			setAgentCode(agentCode)
		}, false, navigateBack)
	}, []);

	const sendData = async () => {
		Swal.showLoading()
		await requestApi(REFERRER.CREATE_TERMINATED, {
			data: {
				id: formData.id,
				agentCode
			}
		}).then(({ data }) => {
			Swal.close();
			if (data?.status === 'success') {
				localStorage.setItem('tab', 0);
				navigateBack();
				localStorage.removeItem("refferer_memory")
				Swal.fire({
					icon: 'success',
					text: 'Data berhasil disimpan'
				});
			}
		}).catch(err => {
			Swal.close();
			if (err?.data) {
				var arrayError = [];
				for (let [key, value] of Object.entries(err.data)) {
					arrayError.push(value)
				}
				var errorJoin = arrayError.join('<br>');

				Swal.fire({
					icon: 'error',
					text: errorJoin
				});
			} else if (err?.message) {
				Swal.fire({
					icon: 'error',
					text: err.message
				});
			} else {
				Swal.fire({
					icon: 'error',
					text: 'Bad request'
				});
			}
		})
	}

	const detail = async (ktpNumber) => {
		if (!ktpNumber) {
			if (!fieldTouched.ktpNumber) {
				setFieldTouched((prevState) => ({ ...prevState, ['ktpNumber']: true }))
			}
			return
		}
		Swal.showLoading()
		await requestApi(REFERRER.REFERRER_TERMINATED, {
			params: {
				ktpNumber
			}
		}).then(({ data }) => {
			Swal.close();
			if (data?.status === 'success') {
				setFormData(data.data)
			}
		}).catch(err => {
			setFormData(null)
			Swal.close();
			if (err?.data) {
				var arrayError = [];
				for (let [key, value] of Object.entries(err.data)) {
					arrayError.push(value)
				}
				var errorJoin = arrayError.join('<br>');

				Swal.fire({
					icon: 'error',
					text: errorJoin
				});
			} else if (err?.message) {
				Swal.fire({
					icon: 'error',
					text: err.message
				});
			} else {
				Swal.fire({
					icon: 'error',
					text: 'Bad request'
				});
			}
		})
	}


	return (
		<Div className='page-wrapper-mobile'>

			{/* 🔥 HEADER */}
			<MobileHeader
				backIcon
				headerTx={"Daftar Ulang Referrer"}
				backOnClick={navigateBack}
			/>
			<Formik
				initialValues={{
					ktpNumber: ''
				}}
				enableReinitialize={true}
				validationSchema={addReferrerTerminatedSchema}
				onSubmit={(values) => {
					sendData()
				}}
			>
				{({ errors, values, handleSubmit, setValues }) => {

					function formikSetValue(field, value) {
						setValues({
							...values,
							[field]: value
						})
					}
					return (
						<Form style={{ width: '100%' }}>
							{/* 🔥 CONTENT */}
							<ContentWrapper isMobile>


								{/* 🔥 typography */}
								<Typography fontSize={16} fontWeight={600}>Silakan Isi No KTP Referrer</Typography>

								{/* 🔥 input with icon left/right */}

								<Div sx={{ mt: 2 }}>
									<Field name="ktpNumber">
										{({
											field,
											value,
											form: { handleChange },
											meta,
										}) => (
											<>
												<InputIcon
													{...field}
													name="ktpNumber"
													value={meta.value}
													type="number"
													required
													onChange={handleChange}
													inputLabel={"Nomor KTP"}
													placeholder={"Nomor KTP"}
													rightIcon={<SearchIcon onClick={() => detail(meta.value)} />}
													onBlur={() => {
														if (!fieldTouched.ktpNumber) {
															setFieldTouched((prevState) => ({ ...prevState, ['ktpNumber']: true }))
														}
													}}

												/>
												{(fieldTouched.ktpNumber && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
											</>
										)}
									</Field>

								</Div>

								{
									formData != null &&
									<Div sx={{ mb: 2, mt: 2 }}>
										<Card variant="outlined" sx={{
											padding: "12px"
										}}>
											<Row className='p-2'>
												<Col>
													<Typography fontSize={12}>Nama Referrer</Typography>
												</Col>
												<Col>
													<Typography fontSize={12} fontWeight={600} textAlign={"right"}>{formData?.name}</Typography>
												</Col>
											</Row>
											<Row className='p-2'>
												<Col>
													<Typography fontSize={12}>No. Hp</Typography>
												</Col>
												<Col>
													<Typography fontSize={12} fontWeight={600} textAlign={"right"}>{formData?.phoneNumber}</Typography>
												</Col>
											</Row>
											<Row className='p-2'>
												<Col>
													<Typography fontSize={12}>Email</Typography>
												</Col>
												<Col>
													<Typography fontSize={12} fontWeight={600} textAlign={"right"}>{formData?.email}</Typography>
												</Col>
											</Row>
											<Row className='p-2 bt-4'>
												<Col>
													<Typography fontSize={12}>Kode Referral</Typography>
												</Col>
												<Col>
													<Typography fontSize={12} fontWeight={600} textAlign={"right"}>{formData?.referrerCode}</Typography>
												</Col>
											</Row>
											<Row className='p-2 bt-4'>
												<Col>
													<Typography fontSize={12}>Status</Typography>
												</Col>
												<Col className='flex-justify-end'>
													<Chip
														label={formData?.referralStatus === "WAITING_VERIFICATION" ? "WAITING VERIFICATION" : formData?.referralStatus}
														size="small"
														color={formData?.referralStatus === "TERMINATED" ? "error" : "success"}
														sx={{ borderRadius: '5px' }}
													/>
												</Col>
											</Row>
											{formData?.referralStatus === "TERMINATED" && (
												<Row className='p-2'>
													<Col>
														<Typography fontSize={12}>Tanggal Terminate</Typography>
													</Col>
													<Col>
														<Typography fontSize={12} fontWeight={600} textAlign={"right"}>
															{formData?.expiredDate ? convertDate(formData?.expiredDate) : '-'}
														</Typography>
													</Col>
												</Row>
											)}
											<Row className='p-2 bt-4'>
												<Col>
													<Typography fontSize={12}>Nomor Identitas</Typography>
												</Col>
												<Col>
													<Typography fontSize={12} fontWeight={600} textAlign={"right"}>{formData?.ktpNumber}</Typography>
												</Col>
											</Row>
											<Row className='p-2'>
												<Col>
													<Typography fontSize={12}>Tanggal Lahir</Typography>
												</Col>
												<Col>
													<Typography fontSize={12} fontWeight={600} textAlign={"right"}>{!formData?.birthDate ? '-' : convertDate(formData?.birthDate)}</Typography>
												</Col>
											</Row>
											<Row className='p-2'>
												<Col>
													<Typography fontSize={12}>Nama Bank</Typography>
												</Col>
												<Col>
													<Typography fontSize={12} fontWeight={600} textAlign={"right"}>{formData?.bankName}</Typography>
												</Col>
											</Row>
											<Row className='p-2'>
												<Col>
													<Typography fontSize={12}>Nomor Rekening</Typography>
												</Col>
												<Col>
													<Typography fontSize={12} fontWeight={600} textAlign={"right"}>{formData?.accountNumber}</Typography>
												</Col>
											</Row>
											<Row className='p-2'>
												<Col>
													<Typography fontSize={12}>No NPWP</Typography>
												</Col>
												<Col>
													<Typography fontSize={12} fontWeight={600} textAlign={"right"}>{formData?.npwpNumber ? formData?.npwpNumber : '-'}</Typography>
												</Col>
											</Row>
											<Row className='p-2'>
												<Col>
													<Typography fontSize={12}>Agen</Typography>
												</Col>
												<Col>
													<Typography fontSize={12} fontWeight={600} textAlign={"right"}>{formData?.agent ? `${formData?.agent.name} - ${formData?.agent.agentCode}` : '-'}</Typography>
												</Col>
											</Row>
										</Card>
									</Div>
								}

							</ContentWrapper>

							{/* 🔥 FOOTER */}
							<MobileFooter>
								<DialogActions className='custom-btn'>
									<ButtonStyled
										disabled={!formData}
										btnText={"Kirim"}
										preset={"primary"}
										onClick={handleSubmit}
									/>

								</DialogActions>

							</MobileFooter>
						</Form>
					)
				}}

			</Formik>
		</Div>

	);
};

export default WebviewAddReferrerTerminated;